import { isRouteErrorResponse, useRouteError } from 'react-router';
import { env } from '@/config/env';
import { Button } from '@/shared/ui';

/** Last-resort error UI for render errors and failed lazy route loads (e.g. after a deploy). */
export function RouteErrorBoundary() {
  const error = useRouteError();
  const title = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : 'Something went wrong';

  return (
    <main className="auth">
      <div className="auth__panel">
        <section className="auth__card" role="alert" aria-labelledby="error-title">
          <header className="auth__head">
            <h1 className="auth__title" id="error-title">
              {title}
            </h1>
            <p className="auth__lead">
              An unexpected error occurred. Reloading the page usually helps.
            </p>
          </header>
          {env.isDevelopment && error instanceof Error && (
            <p className="error-state">{error.stack ?? error.message}</p>
          )}
          <Button
            variant="primary"
            block
            onClick={() => {
              window.location.assign('/');
            }}
          >
            Reload portal
          </Button>
        </section>
      </div>
    </main>
  );
}
